import Header from './Header';
import Footer from './Footer';
import Home from '../pages/home/Home';
import Leagues from '../pages/leagues/Leagues';
import PremierTeams from '../pages/leagues/PremierTeams';
import TeamProfile from '../pages/TeamProfile';
import PlayerProfile from '../pages/PlayerProfile';
import WhoWeAre from '../pages/whoweare/WhoWeAre';
import Btcl100Club from '../pages/Btcl100Club';
import Btcl100Balls from '../pages/Btcl100Balls';
import Contact from '../pages/Contact';
import MobContact from '../Components/MobileComponents/MobContact';
import ScoreCard from '../pages/ScoreCard';
import News from '../pages/News';
import ListingPage from '../pages/ListingPage';
import Leaderboard from '../pages/Leaderboard';
import PlayingCondition from '../pages/PlayingCondition';
import About from '../pages/About';
import Constitution from '../pages/Constitution';
import Discipline from '../pages/Discipline';
import CommitteePage from '../pages/CommitteePage';
import AccountingPage from '../pages/AccountingPage';
import { Routes, Route } from "react-router-dom";
import useBreakpoint from '../hooks/useBreakpoint';
function Layout() {
    const { isDesktop, width } = useBreakpoint();
    const headerHeight = isDesktop ? '124px' : '150px';

    return (
        <div style={{ width: '100%', overflowX: 'hidden', position: 'relative' }}>
            <Header />
            <div style={{ width: '100%', overflowX: 'hidden', paddingTop: headerHeight }}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="news-list" element={<ListingPage type="news" />} />
                    <Route path="videos-list" element={<ListingPage type="videos" />} />
                    <Route path="notices-list" element={<ListingPage type="notices" />} />
                    <Route path="leagues" element={<Leagues />} />
                    <Route path="leagues/:id" element={<PremierTeams />} />
                    <Route path="team-profile/:club_id/:team_id" element={<TeamProfile />} />
                    <Route path="player-profile/:id" element={<PlayerProfile />} />
                    <Route path="who-we-are/:id" element={<WhoWeAre />} />
                    <Route path="btcl-100-club" element={<Btcl100Club />} />
                    <Route path="btcl-100-balls" element={<Btcl100Balls />} />
                    <Route path="view-score-card/:matchId" element={<ScoreCard />} />
                    {width > 600
                        ? <Route path="contact" element={<Contact />} />
                        : <Route path="contact" element={<MobContact />} />
                    }
                    <Route path="/news/:id" element={<News />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/playing-condition" element={<PlayingCondition />} />
                    <Route path="/about-btcl" element={<About />} />
                    <Route path="/constitution" element={<Constitution />} />
                    <Route path="/discipline" element={<Discipline />} />
                    <Route path="/committee" element={<CommitteePage />} />
                    <Route path="/accounting" element={<AccountingPage />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </div>
            <div style={{ backgroundColor: 'var(--blue)' }}>
                <Footer />
            </div>
        </div>

    );

}

export default Layout